
import {
  computed,
  defineComponent, nextTick, reactive, watch,
} from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarCstIcms from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarCstIcms.vue';
import SelecionarCstIpi from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarCstIpi.vue';
import SelecionarCstPis from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarCstPis.vue';
import SelecionarCstCofins from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarCstCofins.vue';
import SelecionarOrigemMercadoria from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarOrigemMercadoria.vue';
import SelecionarModalidadeBaseCalculoIcms from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarModalidadeBaseCalculoIcms.vue';
import SelecionarModalidadeBaseCalculoIcmsSubstituicao from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarModalidadeBaseCalculoIcmsSubstituicao.vue';
import SelecionarCodigoEnquadramentoIpi from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarCodigoEnquadramentoIpi.vue';
import SelecionarTipoCalculoImposto from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarTipoCalculoImposto.vue';
import SelecionarCest from '@/components/Cadastros/Produtos/SelecionarCest.vue';
import SelecionarCsosn from '@/components/Cadastros/Tributacoes/CenariosFiscais/SelecionarCsosn.vue';
import { INotaFiscalItemImposto, INotaFiscalItemImpostoIbsCbs } from '@/models/Entidades/Fiscal/INotaFiscal';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import SelecionarSimNao from '@/core/components/Tela/SelecionarSimNao.vue';

export default defineComponent({
  name: 'NotaFiscalItemImpostos',
  props: {
    impostos: {
      type: Object as () => INotaFiscalItemImposto,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    atualizarApenasInformacoesFiscais: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Card,
    CampoNumerico,
    SelecionarCstIcms,
    SelecionarCstIpi,
    SelecionarCstPis,
    SelecionarCstCofins,
    SelecionarOrigemMercadoria,
    SelecionarModalidadeBaseCalculoIcms,
    SelecionarModalidadeBaseCalculoIcmsSubstituicao,
    SelecionarCodigoEnquadramentoIpi,
    SelecionarTipoCalculoImposto,
    SelecionarCsosn,
    SelecionarSimNao,
    SelecionarCest,
  },
  emits: ['update:impostos', 'calcular', 'calcularTributacoes'],
  setup(props, { emit }) {
    const state = reactive({
      definirCst: true,
    });

    const computedImpostos = computed({
      get: () => props.impostos,
      set: (valor: INotaFiscalItemImposto) => {
        emit('update:impostos', valor);
      },
    });

    function inicializarIbsCbs() {
      if (!computedImpostos.value.ibsCbs) {
        computedImpostos.value.ibsCbs = {
          codigo: 0,
          codigoNotaFiscalItemImposto: 0,
          codigoSituacaoTributaria: '',
          codigoClassificacaoTributaria: '',
          indicadorDoacao: 0,
          valorBaseCalculoIbsCbs: 0,
          aliquotaIbsUf: 0,
          percentualReducaoAliquotaIbsUf: 0,
          aliquotaEfetivaIbsUf: 0,
          valorIbsUf: 0,
          valorDiferimentoIbsUf: 0,
          valorDevolucaoTributoIbsUf: 0,
          aliquotaIbsMunicipio: 0,
          percentualReducaoAliquotaIbsMunicipio: 0,
          aliquotaEfetivaIbsMunicipio: 0,
          valorIbsMunicipio: 0,
          valorDiferimentoIbsMunicipio: 0,
          valorDevolucaoTributoIbsMunicipio: 0,
          aliquotaCbs: 0,
          percentualReducaoAliquotaCbs: 0,
          aliquotaEfetivaCbs: 0,
          valorCbs: 0,
          valorDiferimentoCbs: 0,
          valorDevolucaoTributoCbs: 0,
          valorIbsTotal: 0,
        } as INotaFiscalItemImpostoIbsCbs;
      }
    }

    function atualizarTotalImpostos() {
      computedImpostos.value.valorTotalTributos = 0;

      computedImpostos.value.valorTotalTributos += computedImpostos.value.icms.valorIcms;
      computedImpostos.value.valorTotalTributos += computedImpostos.value.ipi.valorIpi;
      computedImpostos.value.valorTotalTributos += computedImpostos.value.pis.valorPis;
      computedImpostos.value.valorTotalTributos += computedImpostos.value.cofins.valorCofins;
      computedImpostos.value.valorTotalTributos += computedImpostos.value.importacao.valorImportacao;

      if (computedImpostos.value.ibsCbs) {
        computedImpostos.value.valorTotalTributos += computedImpostos.value.ibsCbs.valorIbsUf || 0;
        computedImpostos.value.valorTotalTributos += computedImpostos.value.ibsCbs.valorIbsMunicipio || 0;
        computedImpostos.value.valorTotalTributos += computedImpostos.value.ibsCbs.valorCbs || 0;
      }
    }

    function calcular() {
      if (props.atualizarApenasInformacoesFiscais) return;
      emit('calcular');
    }

    function calcularTributacoes() {
      console.log('calcularTributacoes chamado', computedImpostos.value.st.margemValorAdicionado);
      if (props.atualizarApenasInformacoesFiscais) return;
      emit('calcularTributacoes');
    }

    function definePreenchimentoCstCsosn() {
      if (state.definirCst) {
        computedImpostos.value.cson = '';
      } else {
        computedImpostos.value.cst = '';
      }
    }

    function verificaEdicaoCampoEInformacaoFiscal(): boolean {
      if (props.atualizarApenasInformacoesFiscais) {
        return false;
      }
      return !props.editavel;
    }

    return {
      props,
      state,
      atualizarTotalImpostos,
      calcular,
      calcularTributacoes,
      computedImpostos,
      definePreenchimentoCstCsosn,
      verificaEdicaoCampoEInformacaoFiscal,
    };
  },
});
